// Open Sans, edclub's UI font. Registered via the FontFace API rather than CSS
// @font-face so Bun emits the files as hashed assets instead of inlining them
// as base64 into the stylesheet.
import regular from './assets/fonts/open-sans-regular.woff2'
import semibold from './assets/fonts/open-sans-600.woff2'
import bold from './assets/fonts/open-sans-700.woff2'

for (const [weight, url] of [
	['400', regular],
	['600', semibold],
	['700', bold]
] as const)
	document.fonts.add(new FontFace('Open Sans', `url(${url}) format('woff2')`, { weight, display: 'swap' }))
